import { Typography } from "@mui/material";
import React from "react";

export default function Subtitle({ children }) {
  return (
    <Typography variant="subtitle1" fontWeight="bold" marginBottom={1}>
      {children}
    </Typography>
  );
}
